import { Button, Icon, TableColumn, Typography } from "@kyan/ui";
import moment from "moment";

import { Krystal } from "#/components/Krystal/Krystal";
import { type ReferralsDetails } from "#/types/referrals";
import { formatAddress } from "#/utils/formatAddress";
import { formatCurrency } from "#/utils/valueFormatters";

export const getColumns = ({
  isSm,
  handleDeleteReferral,
}: {
  isSm: boolean;
  handleDeleteReferral: (referralAddress: string) => void;
}): TableColumn<ReferralsDetails>[] => [
  {
    id: "date",
    header: "Date Joined",
    maxWidth: "100px",
    cell: (row) => {
      return row.isYours ? "" : moment.utc(row.date).format("DD.MM.YYYY.");
    },
  },
  {
    id: "address",
    header: "User Address",
    maxWidth: "100px",
    cell: (row) => {
      return row.isYours ? (
        <div className="flex items-center gap-1.5">
          <Icon size="sm" name="user" className="text-textSecondary" />
          <Typography variant="secondary">You</Typography>
        </div>
      ) : (
        <Typography variant="secondary">
          {formatAddress(row.address)}
        </Typography>
      );
    },
  },
  {
    id: "perpsVolume",
    header: "Perps Volume (notional)",
    cell: (row) => formatCurrency(row.perpsVolume),
  },
  {
    id: "optionsVolume",
    header: "Options Volume (notional)",
    cell: (row) => formatCurrency(row.optionsVolume),
    tooltip: "Option Notional Volume is strike * contracts",
  },
  {
    id: "totalVolume",
    header: "Total Notional Volume",
    cell: (row) => formatCurrency(row?.totalVolume),
  },
  /* TODO: add complexity score and krystals earned when we have the data
  {
    id: "complexityScore",
    header: "Complexity Score",
    cell: (row) => formatValue(row.complexityScore),
  },*/
  {
    id: "referralReward",
    maxWidth: "100px",
    header: (
      <div className="flex items-center">
        <Krystal size={20} />
        <Typography>Referral reward</Typography>
      </div>
    ),
    cell: (row) => (row.isYours ? "" : row.referralReward || "Coming soon"),
  },
  {
    id: "actions",
    maxWidth: "50px",
    header: isSm ? "" : "Actions",
    isEnabled: isSm
      ? true
      : (row) => {
          const hasAlreadyTraded =
            row.perpsVolume > 0 || row.optionsVolume > 0 || row.totalVolume > 0;
          return !row.isYours && !hasAlreadyTraded;
        },
    cell: (row) => {
      const hasAlreadyTraded =
        row.perpsVolume > 0 || row.optionsVolume > 0 || row.totalVolume > 0;
      if (row.isYours || hasAlreadyTraded) {
        return null;
      }
      return (
        <Button
          size="sm"
          tabIndex={-1}
          variant="action"
          className="font-bold"
          onClick={() => handleDeleteReferral(row.address)}
        >
          Remove
        </Button>
      );
    },
  },
];
